export default __webpack_public_path__ + "static/media/large.5c45e4f7.jpg";